import moment from 'moment';

export function getFistLastDay(): { firstDay: Date; lastDay: Date } {
    const date = new Date(), y = date.getFullYear(), m = date.getMonth();
    const firstDay = new Date(y, m, 1);
    const lastDay = new Date(y, m + 1, 0);

    return {
        firstDay, lastDay
    }
}

export const getDateLastHour = (hours: number,format?:string): string => {
    let date = moment();
    date.subtract(hours, 'hours');
    return date.format(format || 'YYYY-MM-DD HH:mm:ss');
}

export const getLastDay = (day: number, format?: string): string => {
    let date = moment();
    date.subtract(day, 'day');
    return date.hours(0).minutes(0).format(format ?? 'YYYY-MM-DD');
}

export const getFutureDay = (day: number, format?: string): string => {
    let date = moment();
    date.add(day, 'day');
    return date.hours(0).minutes(0).seconds(0).milliseconds(0).format(format ?? 'YYYY-MM-DD');
}

export function convertMinutesToHoursAndMinutes(minutes: number): string {
    const duration = moment.duration(minutes, 'minutes');
    const hours = duration.hours();
    const mins = duration.minutes();
    return moment.utc().hours(hours).minutes(mins).format('H:mm');
}

export const getStartOfMonth = (format: string = 'YYYY-MM-DD'): string => {
    return moment().startOf('month').format(format);
}

export const getEndOfMonth = (format: string = 'YYYY-MM-DD'): string => {
    return moment().endOf('month').format(format);
}

export const getHoursAndMinutesByDate = (date: string) => {
    if(!date){
        return '----'
    }
    return  moment(date).format('HH:mm')

}